// Libraries
import React from 'react'
import { ModuleNames } from '../../../constants/componentNames.constants'
import { LocaleCodes } from '../../../constants/localization.constants'
import Layout from '../../layouts/layout'

// modules
import Button from '../../global/button'
import ContentBlock from '../../global/contentBlock'
import Hero from '../../global/hero'
import Marketo from '../../global/marketo'
import SEOTags from '../../global/seoTags'

// styles
import { internalLinkHandler } from '../../../utils/link.utils'
import GlobalContainer from '../../global/globalContainer'
import RawHTML from '../../global/rawHTML'
import Typography from '../../global/typography'
import {
  FormFlexBodyContainer,
  FormFlexContainer,
  FormFlexContentContainer,
  FormFlexFormContainer,
  FormFlexFormIntro,
  FormFlexHeroContainer,
} from './style'

const FlexFormPage = ({ path, pageContext, location }: any) => {
  if (pageContext.formFlexData) {
    let hero
    const pageData = pageContext.formFlexData
    const marketoFormData = pageData.marketoForm
    const pageType = 'formFlex'
    const defaultSlug = pageData.slug ? pageData.slug : ''
    const formType = pageData.formType ? pageData.formType : ''
    const formIntro = pageData.formIntro ? pageData.formIntro : ''
    let rawHTMLData = null

    let defaultLocale: string
    let dynamicPageContent: any[] = []
    if (pageContext && pageContext.pageLocale) {
      defaultLocale = pageContext.pageLocale
    } else {
      defaultLocale = LocaleCodes.ENGLISH.code
    }

    const pageTitle = pageData.pageName ? pageData.pageName : ''

    if (pageData && pageData.hero) {
      hero = (
        <Hero
          data={pageData.hero}
          pageType={pageType}
          locale={defaultLocale}
          showBreadcrumbs={!!pageData.breadcrumb}
          breadcrumb={pageData.breadcrumb}
          pageTitle={pageTitle}
        />
      )
    }

    if (pageData && pageData.flexSection) {
      dynamicPageContent = pageData.flexSection.map((module: any, i: Number) => {
        switch (module.__typename) {
          case ModuleNames.GLOBAL_CONTENT_BLOCK:
            return <ContentBlock data={module} key={`page-component--${i}`}></ContentBlock>
          case ModuleNames.TOPIC_CTA:
            return (
              <Button
                icon={true}
                href={
                  module.internalLink
                    ? internalLinkHandler(module.internalLink)
                    : module.externalUrl
                }
                text={module.text ? module.text : ''}
                type="text-link"
                // className="Hero__Secondary-CTA"
                size={'small'}
                theme={'light'}
                useCase={'formFlex'}
              />
            )
          case ModuleNames.RAW_HTML:
            rawHTMLData = module
            break
        }
      })
    }
    const thankYouPageUrl = pageData?.thankYouPage?.slug ? pageData.thankYouPage.slug : ''

    const formSuccessHandler = (form: any) => {
      if (window && window.hasOwnProperty('MktoForms2')) {
        form.onSuccess(() => {
          window.location.href = thankYouPageUrl
          return false
        })
      }
    }
    const seoData = pageData && pageData.seoMetadata ? pageData.seoMetadata : null

    const siteSection = 'Form Flex'

    const pageInner = (
      <div data-cy={`FlexFormPage`}>
        <SEOTags
          seoMetadata={seoData}
          slug={defaultSlug}
          path={path}
          locale={defaultLocale}
          siteSection={siteSection}
          availableLocales={pageContext.availableLocales}
        />
        <FormFlexHeroContainer>{hero}</FormFlexHeroContainer>

        <FormFlexContainer>
          <GlobalContainer className="formFlex--globalContainer">
            <FormFlexBodyContainer className="formFlex--bodyContainer">
              <FormFlexFormContainer className="formFlex--formContainer">
                {formIntro && (
                  <FormFlexFormIntro>
                    <Typography type="header5" className="formFlex--FormIntro">
                      {formIntro}
                    </Typography>
                  </FormFlexFormIntro>
                )}
                {formType === 'Marketo form' && marketoFormData && marketoFormData.marketoForm && (
                  <Marketo
                    formData={marketoFormData && marketoFormData.marketoForm}
                    formSuccessHandler={formSuccessHandler}
                  />
                )}
                {(formType === 'Marketo form' || formType === 'iFrame') && (
                  <RawHTML data={rawHTMLData} />
                )}
                {formType === 'iFrame' && pageData.iFrameLink && (
                  <iframe
                    width="100%"
                    height="750"
                    src={pageData.iFrameLink}
                    id="iFrame-flexForm"
                    frameBorder="0"
                  />
                )}
              </FormFlexFormContainer>
              <FormFlexContentContainer className="formFlex--contentContainer">
                {dynamicPageContent}
              </FormFlexContentContainer>
            </FormFlexBodyContainer>
          </GlobalContainer>
        </FormFlexContainer>
      </div>
    )
    return (
      <Layout.Template
        lang={defaultLocale}
        slug={defaultSlug}
        minimalHeader={!!pageData.navigationStyle}
        availableLocales={pageContext.availableLocales}>
        {pageInner}
      </Layout.Template>
    )
  }
}

export default FlexFormPage
